import { FC, useCallback } from 'react';
import * as types from '@models/types';
import cn from 'classnames';

import './Tabs.scss';

type TabsProps = {
    contentStyle?: {
        [key: string]: any;
    };
    selectedTab: string | number | null | undefined;
    tabs: types.TabsTitlesTypes[];
    onChange: (id: string) => void;
};

const Tabs: FC<TabsProps> = ({
    tabs,
    selectedTab,
    contentStyle,
    onChange,
    children,
}) => {
    const handleTabClick = useCallback(
        ({ currentTarget }) => {
            const { id } = currentTarget.dataset;
            onChange(id);
        },
        [onChange],
    );
    return (
        <div
            className={cn('tabs', {
                tabs_hidden: !!selectedTab,
            })}
        >
            <div className="tabs__tab-container mb-4">
                {tabs && tabs.length && tabs.map(({ id, label, display }, index) => (
                    // onet should always be hidden.. if we need it back, remove id!=="onet"
                    (id !== "onet" && display === true) && <div
                        key={index}
                        className={cn('tabs__tab', {
                            tabs__tab_active: id === selectedTab,
                        })}
                        data-id={id}
                        onClick={handleTabClick}
                    >
                        {label}
                    </div>
                ))}
            </div>
            <div className="tabs__content" style={contentStyle}>
                {children}
            </div>
        </div>
    );
};

export default Tabs;
